module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/backspace-242bec7b740be02c42a59e5f3df13dd6.svg";